import { render, staticRenderFns } from "./AboutEBM.vue?vue&type=template&id=5791c464&"
import script from "./AboutEBM.vue?vue&type=script&lang=js&"
export * from "./AboutEBM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports